import { IntegrationsView } from 'features/projects';

const ProjectIntegrationsPage = () => <IntegrationsView />;

export default ProjectIntegrationsPage;
